import { ensureString } from 'ensure-string';

export function readTimeCSV(csv) {
  csv = ensureString(csv);
  const lines = csv.split(/\r?\n/);
  const headers = lines
    .shift()
    .split(',')
    .map((h) => h.trim())
    .map((h) => h.replaceAll(/  +/g, ' '));
  const results = [];
  for (let i = 0; i < headers.length; i = i + 2) {
    const result = {
      label: headers[i + 1],
      x: { label: headers[i], data: [] },
      y: { label: headers[i + 1], data: [] },
    };
    results.push(result);
    for (const line of lines) {
      const values = line.split(',');
      result.x.data.push(Number(values[i]));
      result.y.data.push(Number(values[i + 1]));
    }
  }
  return results;
}
